import { SvgIcon } from '@mui/material';

export default function Star(props) {
  return <SvgIcon {...props}>
      <path d="M20 8.10006C20.1 7.60006 19.7 7.00006 19.2 7.00006L13.5 6.20006L10.9 1.00006C10.8 0.800061 10.7 0.70006 10.5 0.60006C10 0.30006 9.4 0.50006 9.1 1.00006L6.6 6.20006L0.9 7.00006C0.6 7.00006 0.4 7.10006 0.3 7.30006C-0.1 7.70006 -0.1 8.30006 0.3 8.70006L4.4 12.7001L3.4 18.4001C3.4 18.6001 3.4 18.8001 3.5 19.0001C3.8 19.5001 4.4 19.7001 4.9 19.4001L10 16.7001L15.1 19.4001C15.2 19.5001 15.4 19.5001 15.6 19.5001C15.7 19.5001 15.7 19.5001 15.8 19.5001C16.3 19.4001 16.7 18.9001 16.6 18.3001L15.6 12.6001L19.7 8.60006C19.9 8.50006 20 8.30006 20 8.10006Z" fill="#FFCF55"/>
  </SvgIcon>;
}
